import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ScrubbingVideoWithFullPage from '../../components/patterns/video/ScrubbingVideoWithFullPage';
import brandMessages from '../../data/brandMessages.json';

/**
 * BrandVideoTemplate 컴포넌트
 * Login.js 전용 브랜드 메시지 비디오 스크러빙 템플릿
 * 모든 설정이 내부에서 처리되는 단순화된 버전
 */
function BrandVideoTemplate() {
  const { t } = useTranslation();

  // 브랜드 메시지 섹션 데이터 - i18n 키를 실제 텍스트로 변환 (내부 처리)
  const sections = brandMessages.sections.map(section => ({
    ...section,
    title: section.title && section.title.startsWith('brandMessages.') 
      ? t(section.title) 
      : section.title,
    subtitle: section.subtitle && section.subtitle.startsWith('brandMessages.') 
      ? t(section.subtitle) 
      : section.subtitle
  }));

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        overflow: 'visible',
      }}
    >
      {/* 스크러빙 비디오 섹션 */}
      <ScrubbingVideoWithFullPage
        sections={sections}
      />
    </Box>
  );
}

export default BrandVideoTemplate; 